import React from 'react';
export function Terms26() {
  return <div className="pt-20" data-id="element-1894">
      {/* Hero */}
      <section className="pt-16 pb-12 md:pt-24 md:pb-16 bg-gradient-to-br from-gray-50 to-white" data-id="element-1895">
        <div className="container-custom" data-id="element-1896">
          <div className="max-w-4xl mx-auto text-center" data-id="element-1897">
            <h1 className="mb-6" data-id="element-1898">HIRE Advantage Agreement</h1>
            <p className="text-body-large text-gray-600" data-id="element-1899">
              Terms and Conditions of Service
            </p>
          </div>
        </div>
      </section>

      {/* Agreement Content */}
      <section className="section-padding bg-white" data-id="element-1900">
        <div className="container-custom" data-id="element-1901">
          <div className="max-w-4xl mx-auto prose prose-lg" data-id="element-1902">
            {/* Preamble */}
            <div className="mb-12 bg-gray-50 rounded-lg p-6 border-l-4 border-mint" data-id="element-1903">
              <p className="leading-relaxed" data-id="element-1904">
                This HIRE Advantage Agreement (together with all applicable
                Services Order(s) and addenda, executed hereunder, the
                "Agreement") is entered into by and between the HIRE entity
                identified in a Service Order ("HIRE") and the counterparty to
                that Service Order ("Client") and contains the terms and
                conditions that govern Client's access to and use of the Scope
                of Services (see defined below). This agreement is effective
                when Client executes a Services Order referencing this Agreement
                (the "Effective Date").
              </p>
            </div>

            {/* 1. Introduction & Recitals */}
            <div className="mb-12" data-id="element-1905">
              <h2 className="text-2xl font-bold text-deep-blue mb-4" data-id="element-1906">
                1. Introduction & Recitals
              </h2>
              <p className="leading-relaxed" data-id="element-1907">
                HIRE provides high-performance recruiting solutions designed to
                scale businesses. Under this Agreement, HIRE will deliver its
                Proprietary Recruiting System, which combines advanced
                recruiting services with consulting, coaching, and ongoing
                support to optimize candidate experience, onboarding, and
                retention.
              </p>
            </div>

            {/* 2. Definitions */}
            <div className="mb-12" data-id="element-1908">
              <h2 className="text-2xl font-bold text-deep-blue mb-4" data-id="element-1909">
                2. Definitions
              </h2>

              <div className="space-y-4" data-id="element-1910">
                <div data-id="element-1911">
                  <p className="font-semibold text-deep-blue mb-1" data-id="element-1912">Campaign:</p>
                  <p className="leading-relaxed" data-id="element-1913">
                    A set of 1–10 marketing ads used within a geographic region.
                  </p>
                </div>

                <div data-id="element-1914">
                  <p className="font-semibold text-deep-blue mb-1" data-id="element-1915">
                    Campaign Launch:
                  </p>
                  <p className="leading-relaxed" data-id="element-1916">
                    Date when applicant tracking system is live (system of
                    record for Client to track Recruits) and targeted ad
                    campaigns are posted.
                  </p>
                </div>

                <div data-id="element-1917">
                  <p className="font-semibold text-deep-blue mb-1" data-id="element-1918">Ad Spend:</p>
                  <p className="leading-relaxed" data-id="element-1919">
                    The amount invested by the Client for advertising campaigns,
                    paid to a third-party.
                  </p>
                </div>

                <div data-id="element-1920">
                  <p className="font-semibold text-deep-blue mb-1" data-id="element-1921">
                    Proprietary Recruiting System:
                  </p>
                  <p className="leading-relaxed" data-id="element-1922">
                    HIRE's exclusive methods, processes, training materials, and
                    technology used by HIRE.
                  </p>
                </div>

                <div data-id="element-1923">
                  <p className="font-semibold text-deep-blue mb-1" data-id="element-1924">Recruit:</p>
                  <p className="leading-relaxed" data-id="element-1925">
                    A candidate who is sourced by HIRE Campaigns and completed
                    the HIRE-provided onboarding form or Client Rep Agreement.
                  </p>
                </div>

                <div data-id="element-1926">
                  <p className="font-semibold text-deep-blue mb-1" data-id="element-1927">
                    Qualified HIRE:
                  </p>
                  <p className="leading-relaxed" data-id="element-1928">
                    A Qualified HIRE has completed their first day participating
                    in either Field sales activity, or Formal entry into the
                    Client's sales training program (e.g., sales school),
                    whichever occurs first.
                  </p>
                </div>

                <div data-id="element-1929">
                  <p className="font-semibold text-deep-blue mb-1" data-id="element-1930">
                    Active HIRE:
                  </p>
                  <p className="leading-relaxed" data-id="element-1931">
                    A Qualified HIRE who has completed their first 30 days with
                    the Client and remains actively engaged with the Client's
                    business as a seller of Client's wares or services.
                  </p>
                </div>

                <div data-id="element-1932">
                  <p className="font-semibold text-deep-blue mb-1" data-id="element-1933">
                    Qualified HIRE Date:
                  </p>
                  <p className="leading-relaxed" data-id="element-1934">
                    The date the Recruit completed their first day participating
                    in either Field sales activity, or Formal entry into the
                    Client's sales training program (e.g., sales school),
                    whichever occurs first.
                  </p>
                </div>

                <div data-id="element-1935">
                  <p className="font-semibold text-deep-blue mb-1" data-id="element-1936">
                    Active HIRE Date:
                  </p>
                  <p className="leading-relaxed" data-id="element-1937">
                    The date the Qualified HIRE completed their first 30 days
                    with the Client.
                  </p>
                </div>

                <div data-id="element-1938">
                  <p className="font-semibold text-deep-blue mb-1" data-id="element-1939">Services:</p>
                  <p className="leading-relaxed" data-id="element-1940">
                    Services listed in section 3.
                  </p>
                </div>

                <div data-id="element-1941">
                  <p className="font-semibold text-deep-blue mb-1" data-id="element-1942">
                    Services Order:
                  </p>
                  <p className="leading-relaxed" data-id="element-1943">
                    The document by which Client orders, and HIRE agrees to
                    provide, Services Pursuant to this Agreement.
                  </p>
                </div>
              </div>
            </div>

            {/* 3. Scope of Services */}
            <div className="mb-12" data-id="element-1944">
              <h2 className="text-2xl font-bold text-deep-blue mb-4" data-id="element-1945">
                3. Scope of Services
              </h2>
              <p className="leading-relaxed mb-6" data-id="element-1946">
                As part of this Agreement, HIRE shall provide the following
                services, aligned to the fee categories in Section 4:
              </p>

              <div className="space-y-6" data-id="element-1947">
                <div data-id="element-1948">
                  <h3 className="text-xl font-semibold text-deep-blue mb-3" data-id="element-1949">
                    Build
                  </h3>
                  <ul className="list-disc ml-6 space-y-2" data-id="element-1950">
                    <li data-id="element-1951">Custom Recruiting System Buildout</li>
                    <li data-id="element-1952">ATS Integration & Tracking</li>
                    <li data-id="element-1953">Initial Setup of Automated Applicant Communication</li>
                    <li data-id="element-1954">
                      Initial Configuration of Live Data & Dashboard Access
                    </li>
                  </ul>
                </div>

                <div data-id="element-1955">
                  <h3 className="text-xl font-semibold text-deep-blue mb-3" data-id="element-1956">
                    Platform
                  </h3>
                  <ul className="list-disc ml-6 space-y-2" data-id="element-1957">
                    <li data-id="element-1958">
                      Access to HIRE's proprietary recruiting platform,
                      integrations, dashboards, and reporting tools
                    </li>
                    <li data-id="element-1959">Ongoing Ad Performance Analysis & Adjustments</li>
                    <li data-id="element-1960">Monthly Executive Recruiting Review</li>
                    <li data-id="element-1961">
                      Ongoing Recruiting Best Practice Training (including
                      webinars)
                    </li>
                    <li data-id="element-1962">
                      Hiring Manager Support (1:1 training, auditing, coaching)
                    </li>
                    <li data-id="element-1963">Performance Benchmarking</li>
                  </ul>
                </div>

                <div data-id="element-1964">
                  <h3 className="text-xl font-semibold text-deep-blue mb-3" data-id="element-1965">
                    Campaign
                  </h3>
                  <ul className="list-disc ml-6 space-y-2" data-id="element-1966">
                    <li data-id="element-1967">
                      Targeted Ad Campaigns (copywriting, branding, posting job
                      listings)
                    </li>
                    <li data-id="element-1968">Pre-Screening & Pre-Qualification</li>
                    <li data-id="element-1969">Done-for-You Screening Calls</li>
                    <li data-id="element-1970">
                      Pre-Qualified Interviews Booked into Client's Calendar
                    </li>
                  </ul>
                </div>

                <div data-id="element-1971">
                  <h3 className="text-xl font-semibold text-deep-blue mb-3" data-id="element-1972">
                    Recruiter
                  </h3>
                  <p className="leading-relaxed mb-3" data-id="element-1973">
                    When the Recruiter service is selected, HIRE replaces the
                    Client's in-house recruiter function. Under this service:
                  </p>
                  <ul className="list-disc ml-6 space-y-2" data-id="element-1974">
                    <li data-id="element-1975">
                      HIRE provides a recruiter aligned with the Client's
                      campaigns.
                    </li>
                    <li data-id="element-1976">
                      The Client no longer conducts hiring meetings with a
                      hiring manager or recruiter.
                    </li>
                    <li data-id="element-1977">
                      Instead, the Client accepts or rejects candidates provided
                      by HIRE prior to the candidate attending Sales School.
                    </li>
                  </ul>
                </div>

                <div data-id="element-1978">
                  <h3 className="text-xl font-semibold text-deep-blue mb-3" data-id="element-1979">
                    Placement
                  </h3>
                  <ul className="list-disc ml-6 space-y-2" data-id="element-1980">
                    <li data-id="element-1981">Candidate Experience Optimization</li>
                    <li data-id="element-1982">Onboarding System Buildout</li>
                    <li data-id="element-1983">Early Retention Strategy Development</li>
                    <li data-id="element-1984">
                      Virtual Sales Schools and related training/consulting to
                      support candidate readiness and retention
                    </li>
                  </ul>
                </div>
              </div>

              <div className="mt-6 bg-gray-50 rounded-lg p-4 border-l-4 border-mint" data-id="element-1985">
                <p className="text-sm leading-relaxed" data-id="element-1986">
                  <strong data-id="element-1987">General Terms of Service Delivery:</strong> Services
                  are delivered in a commercially reasonable manner and may be
                  adjusted by HIRE to reflect evolving best practices. Certain
                  services, such as virtual sales schools, may be subject to
                  schedule availability.
                </p>
              </div>
            </div>

            {/* 4. Payment Terms */}
            <div className="mb-12" data-id="element-1988">
              <h2 className="text-2xl font-bold text-deep-blue mb-4" data-id="element-1989">
                4. Payment Terms
              </h2>

              <h3 className="text-xl font-semibold text-deep-blue mb-3" data-id="element-1990">
                4.1 Product Fees
              </h3>
              <p className="leading-relaxed mb-4" data-id="element-1991">
                Client agrees to pay the following Product Fees in accordance
                with the amounts and rates set forth in the applicable Services
                Order:
              </p>

              <div className="space-y-4 mb-6" data-id="element-1992">
                <div data-id="element-1993">
                  <p className="font-semibold text-deep-blue mb-1" data-id="element-1994">
                    Build (One-Time):
                  </p>
                  <p className="leading-relaxed" data-id="element-1995">
                    A one-time setup fee, invoiced and due upon execution of the
                    Services Order.
                  </p>
                </div>

                <div data-id="element-1996">
                  <p className="font-semibold text-deep-blue mb-1" data-id="element-1997">
                    Platform (Recurring Monthly, Includes One Campaign):
                  </p>
                  <p className="leading-relaxed" data-id="element-1998">
                    A recurring monthly fee that provides ongoing access to
                    HIRE's proprietary recruiting platform, integrations,
                    dashboards, reporting tools, and related support services.
                    The Platform Fee includes management of one (1) campaign.
                    The first Platform Fee is due upon execution of the Services
                    Order; the second Platform Fee is due one (1) month after
                    project launch; each subsequent Platform Fee is due on the
                    monthly anniversary of the second payment.
                  </p>
                </div>

                <div data-id="element-1999">
                  <p className="font-semibold text-deep-blue mb-1" data-id="element-2000">
                    Recruiter (Recurring Monthly):
                  </p>
                  <p className="leading-relaxed" data-id="element-2001">
                    A recurring monthly fee per recruiter provided by HIRE.
                    Recruiter quantity must equal the number of active campaigns
                    under management. The first Recruiter Fee is due upon
                    execution of the Services Order; the second Recruiter Fee is
                    due one (1) month after project launch; each subsequent
                    Recruiter Fee is due on the monthly anniversary of the
                    second payment.
                  </p>
                </div>

                <div data-id="element-2002">
                  <p className="font-semibold text-deep-blue mb-1" data-id="element-2003">
                    Additional Campaign(s) (Recurring Monthly):
                  </p>
                  <p className="leading-relaxed" data-id="element-2004">
                    A recurring monthly fee per additional campaign beyond the
                    one included in the Platform Fee. The first Campaign Fee is
                    due upon execution of the Services Order; the second
                    Campaign Fee is due one (1) month after project launch; each
                    subsequent Campaign Fee is due on the monthly anniversary of
                    the second payment.
                  </p>
                </div>

                <div data-id="element-2005">
                  <p className="font-semibold text-deep-blue mb-1" data-id="element-2006">
                    Placement (Recurring Monthly, Billed in Arrears):
                  </p>
                  <p className="leading-relaxed" data-id="element-2007">
                    A recurring monthly fee based on the number of Active
                    Recruits in the prior monthly cycle, billed in arrears.
                    Recurring Placement Fees commence on the Qualified Recruit
                    Date and continue monthly for up to twelve (12) months from
                    each Active Recruit Date. These Placement Fees survive
                    termination of this Agreement and remain payable for all
                    Active Recruits delivered prior to termination.
                  </p>
                </div>
              </div>

              <h3 className="text-xl font-semibold text-deep-blue mb-3" data-id="element-2008">
                4.2 Payment Schedule
              </h3>
              <ul className="list-disc ml-6 space-y-2 mb-6" data-id="element-2009">
                <li data-id="element-2010">All payments due upon receipt.</li>
                <li data-id="element-2011">
                  The One-Time Build & Implementation Fee, as well as the first
                  month's Platform Fee and Managed Campaign Fee(s), are due upon
                  execution of this Agreement and before HIRE begins the
                  campaign and account build.
                </li>
                <li data-id="element-2012">
                  Subsequent Platform Fee and Managed Campaign Fee(s) are due
                  one (1) month after the ads/campaign begins and on the same
                  day each month thereafter (no later than the 28th of the
                  month).
                </li>
                <li data-id="element-2013">
                  Recurring Placement Fees are invoiced and due at the end of
                  each monthly cycle based on the number of Active HIREs. Client
                  hereby authorizes HIRE to automatically process such payments
                  via ACH transfer or credit card on file. Payments made by
                  credit card shall be subject to a processing surcharge of
                  three percent (3%).
                </li>
              </ul>

              <div className="bg-soft-gray rounded-lg p-4 border-l-4 border-mint mb-6" data-id="element-2014">
                <p className="font-semibold text-deep-blue mb-2" data-id="element-2015">
                  Late Payment Penalties:
                </p>
                <p className="leading-relaxed" data-id="element-2016">
                  A five-day grace period applies. After five days, unpaid
                  amounts will incur a 5% monthly interest fee. Client agrees
                  HIRE may suspend all services and withhold all deliverables
                  immediately upon nonpayment, without liability, until account
                  is current.
                </p>
              </div>

              <h3 className="text-xl font-semibold text-deep-blue mb-3" data-id="element-2017">
                4.3 Campaign Scope & Expansion
              </h3>
              <div className="space-y-4 mb-6" data-id="element-2018">
                <div data-id="element-2019">
                  <p className="font-semibold text-deep-blue mb-1" data-id="element-2020">
                    Number of Contracted Campaigns:
                  </p>
                  <p className="leading-relaxed" data-id="element-2021">
                    The Client and HIRE agree that this Agreement covers
                    campaign(s), with each campaign defined as up to ten (10)
                    managed ads in a particular geographic region.
                  </p>
                </div>

                <div data-id="element-2022">
                  <p className="font-semibold text-deep-blue mb-1" data-id="element-2023">
                    Additional Campaign Expansion:
                  </p>
                  <p className="leading-relaxed" data-id="element-2024">
                    The Client may expand by adding campaigns beyond the
                    initially agreed number. Each additional campaign will be
                    billed at the rate on the service order, contingent on
                    HIRE's capacity and mutual agreement.
                  </p>
                </div>

                <div data-id="element-2025">
                  <p className="font-semibold text-deep-blue mb-1" data-id="element-2026">
                    Campaign Reduction:
                  </p>
                  <p className="leading-relaxed" data-id="element-2027">
                    Campaigns may be reduced or paused on a monthly basis with
                    written notice, provided that each campaign operates on a
                    minimum thirty (30)-day cycle. Any reduction shall be
                    prorated and aligned with the Client's monthly billing
                    cycle.
                  </p>
                </div>

                <div data-id="element-2028">
                  <p className="font-semibold text-deep-blue mb-1" data-id="element-2029">
                    Campaign Reallocations & Adjustments:
                  </p>
                  <ul className="list-disc ml-6 space-y-2 mt-2" data-id="element-2030">
                    <li data-id="element-2031">
                      Ad spend may be reallocated across campaigns in real time,
                      based on performance and hiring needs.
                    </li>
                    <li data-id="element-2032">
                      If a campaign is removed and replaced with an entirely new
                      campaign, the Client must confirm with HIRE prior to
                      implementation.
                    </li>
                  </ul>
                </div>
              </div>

              <h3 className="text-xl font-semibold text-deep-blue mb-3" data-id="element-2033">
                4.4 Ad Spend Responsibility
              </h3>
              <p className="leading-relaxed" data-id="element-2034">
                The Client is solely responsible for all advertising costs ("Ad
                Spend") incurred in connection with campaigns under this
                Agreement. Ad Spend is billed directly by the applicable job
                boards or advertising platforms to the Client and is not
                included in HIRE's fees.
              </p>
            </div>

            {/* Section 5 (Performance Commitment) has been removed */}

            {/* 5. Client Responsibilities (was Section 6) */}
            <div className="mb-12" data-id="element-2035">
              <h2 className="text-2xl font-bold text-deep-blue mb-4" data-id="element-2036">
                5. Client Responsibilities
              </h2>
              <p className="leading-relaxed mb-4" data-id="element-2037">The Client shall:</p>
              <ul className="list-disc ml-6 space-y-2" data-id="element-2038">
                <li data-id="element-2039">
                  Have personnel to support interviews, hiring, and onboarding.
                </li>
                <li data-id="element-2040">
                  Allocate proper time for onboarding activities and ongoing
                  meetings.
                </li>
                <li data-id="element-2041">
                  Provide branding materials (logo, tagline, color scheme).
                </li>
                <li data-id="element-2042">Collaborate with HIRE on culture video production.</li>
                <li data-id="element-2043">Set up a dedicated company email for Indeed access.</li>
                <li data-id="element-2044">
                  Provide Google Calendar details for recruiters/screeners.
                </li>
                <li data-id="element-2045">Report sales statistics weekly for Recruits.</li>
                <li data-id="element-2046">
                  Provide necessary materials within seven (7) days of contract
                  execution.
                </li>
              </ul>
            </div>

            {/* 6. Confidentiality & Proprietary Rights (was Section 7) */}
            <div className="mb-12" data-id="element-2047">
              <h2 className="text-2xl font-bold text-deep-blue mb-4" data-id="element-2048">
                6. Confidentiality & Proprietary Rights
              </h2>

              <h3 className="text-xl font-semibold text-deep-blue mb-3" data-id="element-2049">
                6.1 Confidentiality
              </h3>
              <p className="leading-relaxed mb-6" data-id="element-2050">
                The Client agrees all aspects of HIRE's Proprietary Recruiting
                System are confidential and shall not be disclosed, copied, or
                reverse-engineered.
              </p>

              <h3 className="text-xl font-semibold text-deep-blue mb-3" data-id="element-2051">
                6.2 Data Use
              </h3>
              <p className="leading-relaxed mb-4" data-id="element-2052">
                Applicant data is for the Client's internal use only. HIRE
                reserves the right to use campaign data (including
                non-anonymized data where appropriate) for case studies,
                marketing, and analysis, provided Client business interests are
                not compromised.
              </p>
              <p className="leading-relaxed mb-6" data-id="element-2053">
                HIRE may reference Client's name and logo in general marketing
                materials unless Client objects in writing.
              </p>

              <h3 className="text-xl font-semibold text-deep-blue mb-3" data-id="element-2054">
                6.3 Non-Compete & Non-Circumvention
              </h3>
              <p className="leading-relaxed mb-4" data-id="element-2055">
                The Client shall not, directly or indirectly:
              </p>
              <ul className="list-disc ml-6 space-y-2 mb-4" data-id="element-2056">
                <li data-id="element-2057">
                  Replicate, use, or modify HIRE's recruiting system,
                  advertisements, or proprietary materials outside of this
                  Agreement;
                </li>
                <li data-id="element-2058">
                  Transfer, disclose, or make available HIRE's recruiting
                  system, advertisements, or proprietary materials to any third
                  party, including competitors, agencies, or contractors; or
                </li>
                <li data-id="element-2059">
                  Engage in any conduct that has the purpose or effect of
                  circumventing HIRE's role in providing recruiting services.
                </li>
              </ul>
              <p className="leading-relaxed mb-4" data-id="element-2060">
                This restriction applies for a period of two (2) years, or for
                the full duration that Placement Fees remain payable under
                Section 4.1, whichever is longer, after termination of this
                Agreement.
              </p>
              <p className="leading-relaxed" data-id="element-2061">
                Violations entitle HIRE to seek injunctive relief and liquidated
                damages equal to twelve (12) months of lost value.
              </p>
            </div>

            {/* 7. Term, Renewal, and Termination (was Section 8) */}
            <div className="mb-12" data-id="element-2062">
              <h2 className="text-2xl font-bold text-deep-blue mb-4" data-id="element-2063">
                7. Term, Renewal, and Termination
              </h2>

              <h3 className="text-xl font-semibold text-deep-blue mb-3" data-id="element-2064">
                7.1 Term
              </h3>
              <p className="leading-relaxed mb-6" data-id="element-2065">
                This Agreement shall remain in effect for an initial term of 30
                (30) days, beginning on the date of Campaign Launch.
              </p>

              <h3 className="text-xl font-semibold text-deep-blue mb-3" data-id="element-2066">
                7.2 Renewal
              </h3>
              <p className="leading-relaxed mb-6" data-id="element-2067">
                After the initial term, the Agreement renews month-to-month
                unless either party provides at least fourteen (14) days'
                written notice of non-renewal.
              </p>

              <h3 className="text-xl font-semibold text-deep-blue mb-3" data-id="element-2068">
                7.3 Early Termination for Convenience (28-Day Guarantee)
              </h3>
              <p className="leading-relaxed mb-4" data-id="element-2069">
                Notwithstanding any other provision of this Agreement, the
                Client may terminate for convenience at any time within the
                first twenty-eight (28) days following Campaign Launch. In such
                event:
              </p>
              <ul className="list-disc ml-6 space-y-2 mb-4" data-id="element-2070">
                <li data-id="element-2071">
                  HIRE shall refund one hundred percent (100%) of the Build &
                  Implementation Fee
                </li>
                <li data-id="element-2072">No Recurring Placement Fees shall be due.</li>
              </ul>
              <p className="leading-relaxed" data-id="element-2073">
                Upon such termination, both parties are released from all
                further obligations.
              </p>
            </div>

            {/* 8. Dispute Resolution & Governing Law (was Section 9) */}
            <div className="mb-12" data-id="element-2074">
              <h2 className="text-2xl font-bold text-deep-blue mb-4" data-id="element-2075">
                8. Dispute Resolution & Governing Law
              </h2>
              <p className="leading-relaxed" data-id="element-2076">
                This Agreement shall be governed by Arizona law. Disputes shall
                first be resolved through mediation.
              </p>
            </div>

            {/* 9. Indemnification & Limitation of Liability (was Section 10) */}
            <div className="mb-12" data-id="element-2077">
              <h2 className="text-2xl font-bold text-deep-blue mb-4" data-id="element-2078">
                9. Indemnification & Limitation of Liability
              </h2>

              <h3 className="text-xl font-semibold text-deep-blue mb-3" data-id="element-2079">
                Indemnification by Client:
              </h3>
              <p className="leading-relaxed mb-6" data-id="element-2080">
                Client indemnifies HIRE against claims arising from misuse of
                the system, hiring decisions, or breach.
              </p>

              <h3 className="text-xl font-semibold text-deep-blue mb-3" data-id="element-2081">
                Indemnification by HIRE:
              </h3>
              <p className="leading-relaxed mb-6" data-id="element-2082">
                HIRE indemnifies Client against claims resulting from gross
                negligence or intentional misconduct.
              </p>

              <h3 className="text-xl font-semibold text-deep-blue mb-3" data-id="element-2083">
                Limitation of Liability:
              </h3>
              <p className="leading-relaxed" data-id="element-2084">
                HIRE's liability shall not exceed the total fees paid by Client
                in the three months preceding a claim. HIRE shall not be liable
                for indirect or consequential damages.
              </p>
            </div>

            {/* 10. Amendments & Notices (was Section 11) */}
            <div className="mb-12" data-id="element-2085">
              <h2 className="text-2xl font-bold text-deep-blue mb-4" data-id="element-2086">
                10. Amendments & Notices
              </h2>
              <p className="leading-relaxed" data-id="element-2087">
                All amendments must be in writing and signed by both parties.
                Notices must be in writing.
              </p>
            </div>

            {/* 11. Acknowledgment (was Section 12) */}
            <div className="mb-12" data-id="element-2088">
              <h2 className="text-2xl font-bold text-deep-blue mb-4" data-id="element-2089">
                11. Acknowledgment and Acceptance
              </h2>
              <p className="leading-relaxed" data-id="element-2090">
                By signing below, both parties acknowledge they have read,
                understood, and agreed to the terms of this Agreement.
              </p>
            </div>

            {/* EXHIBIT A */}
            <div className="mb-12 bg-gray-50 rounded-lg p-6 border-2 border-deep-blue" data-id="element-2091">
              <h2 className="text-2xl font-bold text-deep-blue mb-4" data-id="element-2092">
                EXHIBIT A – TERMINATION & EXIT PROVISIONS
              </h2>

              <h3 className="text-xl font-semibold text-deep-blue mb-3" data-id="element-2093">
                Termination Conditions:
              </h3>
              <ul className="list-disc ml-6 space-y-2 mb-6" data-id="element-2094">
                <li data-id="element-2095">
                  This Agreement shall renew on a month-to-month basis after the
                  initial thirty (30) day term, unless either party provides
                  fourteen (14) days' written notice of non-renewal.
                </li>
                <li data-id="element-2096">
                  The Client may terminate for convenience within the first
                  twenty eight (28) days of execution pursuant to Section 7.3 of
                  this Agreement.
                </li>
                <li data-id="element-2097">
                  HIRE reserves the right to terminate immediately if the Client
                  fails to make payments or breaches confidentiality
                  obligations.
                </li>
              </ul>

              <h3 className="text-xl font-semibold text-deep-blue mb-3" data-id="element-2098">
                Financial Obligations Upon Termination:
              </h3>
              <ul className="list-disc ml-6 space-y-2 mb-6" data-id="element-2099">
                <li data-id="element-2100">
                  The Client remains responsible for all outstanding invoices up
                  to the termination date.
                </li>
                <li data-id="element-2101">
                  Recurring Placement Fees remain payable for all Active HIREs,
                  up to twelve (12) months from the Active HIRE Date.
                </li>
              </ul>

              <h3 className="text-xl font-semibold text-deep-blue mb-3" data-id="element-2102">
                Survival of Obligations:
              </h3>
              <p className="leading-relaxed mb-6" data-id="element-2103">
                Confidentiality, proprietary rights, and all payment obligations
                (including Recurring Placement Fees) shall survive termination.
              </p>

              <h3 className="text-xl font-semibold text-deep-blue mb-3" data-id="element-2104">
                Post-Termination Use of Intellectual Property & Data:
              </h3>
              <ul className="list-disc ml-6 space-y-2" data-id="element-2105">
                <li data-id="element-2106">
                  The Client shall cease use of any proprietary materials,
                  recruiting systems, training programs, or strategies developed
                  by HIRE.
                </li>
                <li data-id="element-2107">
                  Any materials provided by HIRE (including advertisements,
                  branding, or process structures) shall not be used to
                  replicate services independently or with a third-party vendor.
                </li>
                <li data-id="element-2108">
                  HIRE retains ownership of all data, processes, and
                  confidential information provided during the term.
                </li>
              </ul>
            </div>

            {/* EXHIBIT B */}
            <div className="mb-12 bg-gray-50 rounded-lg p-6 border-2 border-deep-blue" data-id="element-2109">
              <h2 className="text-2xl font-bold text-deep-blue mb-4" data-id="element-2110">
                EXHIBIT B – INDEMNIFICATION & LIMITATION OF LIABILITY
              </h2>

              <h3 className="text-xl font-semibold text-deep-blue mb-3" data-id="element-2111">
                Indemnification by the Client:
              </h3>
              <p className="leading-relaxed mb-4" data-id="element-2112">
                The Client agrees to indemnify, defend, and hold harmless HIRE
                from any claims, damages, or liabilities arising from the
                Client's misuse of the system, hiring decisions, or breach of
                contract.
              </p>
              <p className="leading-relaxed mb-6" data-id="element-2113">
                The Client assumes full responsibility for compliance with
                employment laws and regulations.
              </p>

              <h3 className="text-xl font-semibold text-deep-blue mb-3" data-id="element-2114">
                Indemnification by HIRE:
              </h3>
              <p className="leading-relaxed mb-4" data-id="element-2115">
                HIRE shall indemnify the Client against claims resulting from
                gross negligence or intentional misconduct in delivering
                services under this Agreement.
              </p>
              <p className="leading-relaxed mb-6" data-id="element-2116">
                HIRE is not responsible for hiring outcomes, employee
                performance, misconduct, retention results, or legal disputes
                related to employment practices.
              </p>

              <h3 className="text-xl font-semibold text-deep-blue mb-3" data-id="element-2117">
                Limitation of Liability:
              </h3>
              <p className="leading-relaxed mb-4" data-id="element-2118">
                In no event shall HIRE's total liability exceed the total fees
                paid by the Client in the three (3) months preceding the claim.
              </p>
              <p className="leading-relaxed mb-6" data-id="element-2119">
                HIRE shall not be liable for indirect, incidental, or
                consequential damages, including loss of profits, business
                interruptions, or reputational harm.
              </p>
              <p className="leading-relaxed mb-6" data-id="element-2120">
                Nothing in this section shall limit the Client's obligation to
                pay Recurring Placement Fees or other amounts due under this
                Agreement.
              </p>

              <h3 className="text-xl font-semibold text-deep-blue mb-3" data-id="element-2121">
                Force Majeure:
              </h3>
              <p className="leading-relaxed" data-id="element-2122">
                Neither party shall be held liable for delays or failures in
                performance due to causes beyond their reasonable control,
                including but not limited to natural disasters, labor strikes,
                government actions, or technological failures. Payment
                obligations incurred prior to the force majeure event shall
                remain enforceable and are not excused.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer CTA */}
      <section className="section-padding bg-gray-50" data-id="element-2123">
        <div className="container-custom" data-id="element-2124">
          <div className="max-w-3xl mx-auto text-center" data-id="element-2125">
            <h2 className="mb-6" data-id="element-2126">Questions About This Agreement?</h2>
            <p className="text-body-large mb-8 leading-relaxed" data-id="element-2127">
              We're happy to discuss any questions or concerns you have about
              our service agreement.
            </p>
            <a href="/book-call" className="inline-block bg-mint hover:bg-mint-dark text-deep-blue font-bold px-8 py-4 rounded-lg transition-colors shadow-lg" data-id="element-2128">
              Schedule a Call →
            </a>
          </div>
        </div>
      </section>
    </div>;
}